import React, { useRef } from 'react'; import { DoubleSide } from 'three';
import { useGLTF } from '@react-three/drei'

export function AnM(props) { const group = useRef()
    const { nodes, materials } = useGLTF('3ds/an/AnM.gltf')
    return (
        <group ref={group} {...props} dispose={null}>
            <mesh name="AnM" geometry={nodes.AnM.geometry} material={nodes.AnM.material} rotation={[Math.PI / 2, 0, 0]}
            >
                <meshStandardMaterial
                    attach="material"
                    color="green"
                    metalness={1.0}
                    side={DoubleSide}
                />
            </mesh>
        </group>
    )
}

useGLTF.preload('3ds/an/AnM.gltf')